<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">

    <header class="dashboard-header">
      <div class="dashboard-container">

        <router-link :to="{ name: 'home' }">
          <a href="/" class="dashboard-logo">
            <img src="../../static/styles/mailkit/img/logo2.png" alt="CTMK">
          </a>
        </router-link>

        <main-menu></main-menu>

      </div>
    </header>

    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>

  </div>
</template>

<script>
  import MainMenu from '../components/Menu'

  export default {
    components: {
      'main-menu': MainMenu
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/Main.vue